/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 * Router configuration for Wizard Order report
 *
 * @author Evgeniy Naumov
 * @version 1.22.0
 * @since 1.22.0
 */

 import { EBreadCrumbType } from '../../modules/breadCrumbs/breadCrumbsTypes';
 import { IAppRouterConfiguration } from '../appRouterTypes';
 import { RoutePath } from './routesConstants';

 export const WizardOrderReportConfiguration: IAppRouterConfiguration[] = [
     {
         path: RoutePath.wizardOrderReportFromDashbord,
         breadCrumbs: [EBreadCrumbType.reportsConstructor, EBreadCrumbType.wizardOrderReport],
     },
     {
         path: RoutePath.wizardOrderReportFromAccount,
         breadCrumbs: [
             EBreadCrumbType.accounts,
             EBreadCrumbType.accountId,
             EBreadCrumbType.reportsConstructorFromAccount,
             EBreadCrumbType.wizardOrderReport,
         ],
     },
     {
         path: RoutePath.wizardOrderReportFromAccountList,
         breadCrumbs: [
             EBreadCrumbType.accounts,
             EBreadCrumbType.reportsConstructorFromAccountList,
             EBreadCrumbType.wizardOrderReport,
         ],
     },
     {
         path: RoutePath.wizardOrderReportFromMobileList,
         breadCrumbs: [
             EBreadCrumbType.subscriberMobile,
             EBreadCrumbType.reportsConstructorFromMobileList,
             EBreadCrumbType.wizardOrderReport,
         ],
     },
     {
         path: RoutePath.wizardOrderReportFromAutoReports,
         breadCrumbs: [
             EBreadCrumbType.settingsAutoReports,
             EBreadCrumbType.reportsConstructorFromAutoReports,
             EBreadCrumbType.wizardOrderReport,
         ],
     },
 ];
